const usernames = {
  mediumUsername: "abirwrites",
  hashnodeUsername: "imabp",
};
export default usernames;

